module.exports = __webpack_public_path__ + "img/dlybg02.7d5d1e1a.png";